import './view.scss';

const header = document.querySelector('.header');
const toggle = document.querySelector('.header__sub-menu-toggle');
const subMenu = document.querySelector('.header__sub-menu-container');

document.addEventListener('DOMContentLoaded', function () {
    if (toggle) {
        toggle.addEventListener('click', function (evt) {
            evt.preventDefault();
            header.classList.toggle('header--is-open');
        });
    }
});
document.addEventListener('focusin', function (event) {
    if(subMenu){
        if (!subMenu.contains(document.activeElement) && event.target !== toggle) {
            header.classList.remove('header--is-open');
        }
    }
});


const checkScroll = () => {
    if (window.scrollY > 0) {
        header.classList.add('header--scrolled');
    } else {
        header.classList.remove('header--scrolled');
    }
};

window.addEventListener('scroll', checkScroll);

checkScroll();

